import { Switch, SwitchProps } from 'antd';

import './SwitchWithIcon.scss';

const SwitchWithIcon = ({ ...props }: SwitchProps) => {
  return <Switch {...props} className="SwitchWithIcon" />;
};

export default SwitchWithIcon;
